export const secret_key:string = process.env.REACT_APP_SECRET_KEY ?? "secret"
export const route_prefix:string = process.env.REACT_APP_APP_ROUTE_PREFIX ?? ""